import * as tslib_1 from "tslib";
import { OnInit, EventEmitter } from '@angular/core';
import { ToastService } from 'ng-uikit-pro-standard';
import { SecurityService } from 'src/app/shared/services/security.service';
import { Subject } from 'rxjs';
export class ModalClonarRecorridoComponent {
    constructor(datesService, accesolocalstorage, _messageRendererService, recorridoService, camionService, toastrService) {
        this.datesService = datesService;
        this.accesolocalstorage = accesolocalstorage;
        this._messageRendererService = _messageRendererService;
        this.recorridoService = recorridoService;
        this.camionService = camionService;
        this.toastrService = toastrService;
        this.eventsSubject = new Subject();
        // Input
        this.title = '';
        this.contentText = '';
        this.acceptButtonText = 'Aceptar';
        this.cancelButtonText = 'Cancelar';
        // Output
        this.onAccept = new EventEmitter();
        this.onCancel = new EventEmitter();
        this.FechaRec = null;
        this.loading = false;
        this.processing = false;
        this.listRecorridosCheck = [];
        this.optionsUnidadesDeNegocio = [];
        this.optionsCamion = [];
    }
    ngOnInit() {
        this.rutEmpresa = this.accesolocalstorage.getRutEmpresa();
        this.sucursalCodigo = this.accesolocalstorage.getSucursalCodigo();
        const { initDate, currentDate } = this.datesService.GetStartAndCurrentMonth();
        this.FechaRec = currentDate;
        this.loadCamiones();
    }
    /********* SHOW/HIDE *********/
    show(listRecorridos, acceptCallback = null, cancelCallback = null) {
        console.log('ENTRA EN LA SEGUNDA FUNCION', listRecorridos);
        this.listRecorridosCheck = listRecorridos;
        this.acceptCallback = acceptCallback;
        this.cancelCallback = cancelCallback;
        this.modalClonar.show();
    }
    hide() {
        this.modalClonar.hide();
        return new Promise((resolve) => {
            setTimeout(() => {
                this.processing = false;
            }, 1000);
        });
        //this.processing = false
    }
    /********* SHOW/HIDE *********/
    /********* OPERATIONS *********/
    accept() {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const { currentDate } = this.datesService.GetStartAndCurrentMonth();
            this.processing = true;
            this.listRecorridosCheck.map((x) => {
                x.fecha = this.FechaRec;
            });
            const hayDuplicados = this.verificarDuplicados(this.listRecorridosCheck);
            // if(recorridosDuplicados.length > 0){
            //    this.toastrService.warning("Existen recorridos duplicados");
            //   return;
            // }
            if (hayDuplicados) {
                this.toastrService.warning('Existen recorridos duplicados');
                this.processing = false;
                return;
            }
            else {
                const self = this;
                //Realizar operacion de crear ruta segun la cantidad de recorridos.
                this.listRecorridosCheck.forEach((element) => {
                    element.codigo = null;
                    element.chofer_rut = element.chofer_rut;
                    element.camion_patente = element.patente;
                    element.sucursal_codigo = this.sucursalCodigo;
                    element.rut_empresa = this.rutEmpresa;
                    element.limite_volumen = this.setCamion(element.patente, 1);
                    element.limite_monto = 10000000;
                    element.limite_peso = this.setCamion(element.patente, 0);
                    element.fecha_registro = this.FechaRec;
                    element.fecha = this.FechaRec;
                    element.activo = true;
                    delete element.patente;
                    delete element.recorrido_codigo;
                    delete element.descripcion_camion;
                    delete element.nombre_chofer;
                    delete element.total_facturas;
                    delete element.__typename;
                    delete element.checked;
                    delete element.index;
                });
                const inputParams = {
                    entidad: this.listRecorridosCheck,
                };
                console.log('Carga Finalizada ', inputParams);
                yield this.capturarMovimientoMaquina(inputParams);
                this.toastrService.success('Operación exitosa');
                this.FechaRec = currentDate;
                console.log('Función externa completada. Continuando con la función principal');
                this.onAccept.emit();
                yield this.hide();
            }
        });
    }
    capturarMovimientoMaquina(inputParams) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const self = this;
            const a = yield new Promise((resolve) => {
                // Simulamos una operación asincrónica con setTimeout
                setTimeout(() => {
                    this.recorridoService.GuardarRecorridoClonacion(inputParams, ({ mensajes, respuesta }) => {
                        const ok = respuesta !== null;
                        if (mensajes && mensajes.length > 0) {
                            self._messageRendererService.showErrors(mensajes);
                            self.processing = false;
                            return;
                        }
                        if (mensajes.length == 0 && respuesta.length == 0) {
                            self.toastrService.error('No se han encontrado recorrido para clonar');
                            self.processing = false;
                            return;
                        }
                        if (!ok) {
                            self._messageRendererService.showErrors(mensajes);
                            self.processing = false;
                            return;
                        }
                        const { codigo } = respuesta;
                        resolve(codigo);
                    });
                }, 1000);
            });
            return yield Promise.resolve(a);
        });
    }
    // Función para verificar duplicados en la lista
    verificarDuplicados(lista) {
        const combinacionesVistas = new Set();
        for (const objeto of lista) {
            const combinacion = `${objeto.chofer_rut}-${objeto.patente}`;
            if (combinacionesVistas.has(combinacion)) {
                // Duplicado encontrado
                return true;
            }
            // Agregar la combinación a la lista de combinaciones vistas
            combinacionesVistas.add(combinacion);
        }
        // No se encontraron duplicados
        return false;
    }
    loadCamiones() {
        const inputParams = {
            rut_empresa: this.rutEmpresa,
            sucursal_codigo: this.sucursalCodigo,
            tipobusqueda: 1,
        };
        this.optionsUnidadesDeNegocio = [];
        this.camionService.obtenerCamionSucursalxRutEmpresaSucursal(inputParams, ({ respuesta, mensajes }) => {
            if (mensajes && mensajes.length > 0) {
                this._messageRendererService.showErrors(mensajes);
                return;
            }
            const { registros } = respuesta;
            this.optionsCamion = registros.map((p) => (Object.assign({ value: p.patente, label: p.patente + ' - ' + p.descripcion }, p)));
        });
    }
    setCamion(patente, atributo) {
        this.camion = this.optionsCamion.filter((s) => s.value == patente)[0];
        if (atributo == 1) {
            return this.camion.volumen;
        }
        else {
            return this.camion.peso_maximo;
        }
    }
    cancel() {
        if (this.cancelCallback)
            this.cancelCallback();
        this.onCancel.emit();
        this.hide();
    }
}
